import React from 'react';
import {
  getStatus,
  getStatusLabel,
  StatusIndicatorIcon,
} from '@/components/staffer/AssignmentsBasedGradesTable/Table/Rows/StatusIndicator';
import useGradingStore from '../useGradingStore';

interface StatusProps {
  completedText?: string;
}

const Status = ({ completedText }: StatusProps) => {
  const { assignment, currentUser, submission } = useGradingStore();
  const { low_score_settings: lowScoresSettings } = currentUser;
  const status = getStatus({ assignment, isAssigned: true, lowScoresSettings, submission });

  return (
    <div className="tw-inline-flex tw-items-center tw-gap-1">
      <StatusIndicatorIcon className="tw-mr-1" type={status} />
      <span>{getStatusLabel({ completedText, status })}</span>
    </div>
  );
};

export default Status;
